import { User } from "../../context/AuthContext/types"

/**
 * Map a raw user object received from the API to the `User` interface used
 * throughout the application.
 *
 * @param user Raw user data.
 * @returns Normalised `User` object.
 */
export const userMapping = (user: any) => {
    const userrecived:User = {
        changePassword: user?.changePassword,
        fatherLastName: user?.fatherLastName,
        lastName: user?.lastName,
        motherLastName: user?.motherLastName,
        name: user?.name,
        id: user?.id,
        idRol: user?.idRol,
        rol: user?.rol,
        lifeToken: user?.lifeToken,
        signature: user?.signature,
        token: user?.token,
        userName: user?.userName,
        terminal: user?.terminal,
        tpv: user?.tpv,
        imageUrl:user?.imageUrl,
        treeFirebase:user?.treeFirebase,
        loginRecord:user?.loginRecord
    }
    return userrecived;

}